import React from 'react';
import { Link } from 'react-router-dom';
import MainMenu from './main-menu';
import InquireCTA from './inquire-cta';
import LogoLink from './logo-link';
import UserMenu from './user-menu';
import Phone from './phone';
import MobileHamburgerButton from './mobile-hamburger-button';
import SubMenu from './sub-menu';
import LinkList from './link-list';
import styles from './top-nav.module.scss';
import LayoutContainer from './layout-container';
import { sectionHasExpandablePanel } from '../../utils/linkSectionUtils';
import { TopNavViewProps } from './types';

const TopNavView = ({
  activeMenu,
  activeMenuRef,
  activeSubMenu,
  emitPhoneCallClickEvent,
  emitNavClick,
  firstSubMenuRef,
  isTravelCompany,
  menuNames,
  menus,
  onCloseMenu,
  onClickLink,
  onOpenMobileMenu,
  onReturnToMainMenu,
  onSelectMenu,
  setActiveSubMenu,
  showMobileMenu,
  useSlimNav,
}: TopNavViewProps) => (
  <nav
    aria-label="Main navigation"
    className={`${styles.nav} ${showMobileMenu || activeMenu ? styles.nav__open : ''}`}
    id="top-nav"
  >
    <LayoutContainer className={styles['nav-container']}>
      <div className={styles['nav-top']}>
        <div className={styles['nav-left']}>
          <LogoLink onClick={onClickLink} />
          <Link className={styles['my-trips-link-mobile']} to="/" onClick={onClickLink}>
            MY TRIPS
          </Link>
          <MobileHamburgerButton
            onClick={showMobileMenu ? onCloseMenu : onOpenMobileMenu}
            showMenu={showMobileMenu}
          />
        </div>
        {!useSlimNav && (
        <div className={styles['nav-middle']}>
          <MainMenu
            activeMenu={activeMenu}
            activeMenuRef={activeMenuRef}
            emitNavClick={emitNavClick}
            menuNames={menuNames}
            onSelectMenu={onSelectMenu}
            onCloseMenu={onCloseMenu}
          />
        </div>
        )}
        <div className={styles['nav-right']}>
          <Phone onClick={onClickLink} emitPhoneCallClickEvent={emitPhoneCallClickEvent} />
          <Link className={styles['my-trips-link']} to="/" onClick={onClickLink}>
            MY TRIPS
          </Link>
          <UserMenu onClickLink={onClickLink} />
          <InquireCTA isTravelCompany={isTravelCompany} onClick={onClickLink} />
        </div>
      </div>
      {menus.map((menu) => (
        <SubMenu
          activeMenu={activeMenu}
          activeSubMenu={activeSubMenu}
          firstSubMenuRef={firstSubMenuRef}
          emitNavClick={emitNavClick}
          key={menu.name}
          menu={menu}
          onClickLink={onClickLink}
          onCloseMenu={onCloseMenu}
          onReturnToMainMenu={onReturnToMainMenu}
          setActiveSubMenu={setActiveSubMenu}
        >
          {menu.linkSections
            .filter(sectionHasExpandablePanel)
            .map((linkSection) => (
              <LinkList
                activeSubMenu={activeSubMenu}
                emitNavClick={emitNavClick}
                key={linkSection.name}
                onClickLink={onClickLink}
                linkSection={linkSection}
                setActiveSubMenu={setActiveSubMenu}
              />
            ))}
        </SubMenu>
      ))}
    </LayoutContainer>
  </nav>
);

export default TopNavView;
